import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "mandae-condicao-faixa-peso",
  templateUrl: "./faixa-peso.component.html",
  styleUrls: ["./faixa-peso.component.scss"],
})
export class CondicaoFaixaPesoComponent {
  public formulario: FormGroup;

  public erro = false;

  public mensagem = "";

  @Input()
  public set Data(data) {
    if (data) {
      if (data.valorInicial !== null) {
        this.formulario.get("inicial").setValue(data.valorInicial);
      }

      if (data.valorFinal !== null) {
        this.formulario.get("final").setValue(data.valorFinal);
      }
    }
  }

  @Output()
  public condicaoResponse = new EventEmitter();

  constructor(private formBuilder: FormBuilder) {
    this.formulario = this.formBuilder.group({
      inicial: [null],
      final: [null],
    });
  }

  public mudancaCampo() {
    const inicial = this.formulario.get("inicial").value;
    const final = this.formulario.get("final").value;

    this.erro = false;
    this.mensagem = "";
    this.formulario.get("inicial").setErrors(null);
    this.formulario.get("final").setErrors(null);

    // pelo menos o valor inicial foi preenchido - mesmo que com 0 (zero)
    if (inicial !== null) {
      // se existe valor final, mesmo que com 0 (zero)
      if (final !== null) {
        if (inicial > final) {
          this.formulario.get("inicial").setErrors({ menorQueFinal: true });
          this.formulario.get("final").setErrors({ menorQueFinal: true });
          this.mensagem = "O valor inicial é maior que o final.";
          this.erro = true;

          this.condicaoResponse.emit({
            tipo: "peso",
            error: true,
          });

          return;
        }

        if (inicial === final) {
          this.formulario.get("inicial").setErrors({ menorQueFinal: true });
          this.formulario.get("final").setErrors({ menorQueFinal: true });
          this.mensagem = "O valor inicial é igual ao final.";
          this.erro = true;

          this.condicaoResponse.emit({
            tipo: "peso",
            error: true,
          });

          return;
        }

        this.condicaoResponse.emit({
          tipo: "peso",
          error: false,
          valor: {
            valorInicial: this.formulario.get("inicial").value,
            valorFinal: this.formulario.get("final").value,
          },
        });
      } else {
        this.condicaoResponse.emit({
          tipo: "peso",
          error: false,
          valor: {
            valorInicial: this.formulario.get("inicial").value,
            valorFinal: this.formulario.get("final").value,
          },
        });
      }
    }
  }
}
